import cuid from 'cuid'
import {
  setDoc,
  updateDoc,
  getDoc,
  writeBatch,
  serverTimestamp,
  doc,
  deleteField,
  collection,
  getDocs,
  // where,
} from 'firebase/firestore'
// import { ref, uploadString, getDownloadURL } from 'firebase/storage'
import { httpsCallable } from 'firebase/functions'
// import { getAuth } from 'firebase/auth'
import cloneDeep from 'lodash.clonedeep'
// import equal from 'fast-deep-equal'
// import getFirebase from '../../utils/firebase/firebase'
// import {
//   asyncActionStart,
//   asyncActionFinish,
//   asyncActionError,
// } from '../async/actions'
import {
  saveLocalChoicesList,
  setSavedLists,
  updateMysterySettings as updateMysterySettingsMain,
  setInputEditMode,
  setInputShowMode,
  setScores as setScoresMain,
  setAutoAddCount as setAutoAddCountMain,
  setChoiceHDImages as setChoiceHDImagesMain,
} from '../homepage/actions'
import {
  saveLocalChoicesList as saveLocalChoicesListRIG,
  setSavedLists as setSavedListsRIG,
  updateMysterySettings as updateMysterySettingsRIG,
  setScores as setScoresRIG,
  setAutoAddCount as setAutoAddCountRIG,
  setChoiceHDImages as setChoiceHDImagesRIG,
} from '../rig/actions'
import {
  saveLocalPeopleList,
  setSavedLists as setSavedListsRTG,
  selfJoinGrouping,
  csvGrouping,
} from '../rtg/actions'
import { updateUserCustomization } from '../auth/actions'
import {
  refactorTitle,
  refactorSoundSettings,
  refactorSpinBehavior,
  refactorToolBackgroundSettings,
  removeObjectField,
} from '../../utils'
import {
  firestore,
  auth,
  functions,
  // storage,
} from '../../utils/firebase/firebase'
import {
  updateAllSettings,
  turnOffPremiumSettings,
  resetInitialSettings,
} from '../toolSettings/actions'
import {
  isImageData,
  deleteImagesFromR2,
  uploadImagesToR2,
  prepareImageFormData,
  deleteFolderFromR2,
  cleanupFolderFromR2,
  saveListDataToR2,
  getR2StorageData,
  deleteR2StorageData,
} from '../../utils/imageUtil'
import {
  setCurrentFileKey,
  setCurrentTabData,
  setDataStatus,
  setToolSettingsActiveIndex,
  setFreezeEditing,
  setIsReadingFile,
} from '../common/actions'
// import { entries, setMany, clear } from 'idb-keyval'
import {
  // uploadUserAsset,
  copyStorageFiles,
  deleteUserAsset,
  getUnusedAssetsName,
  // copyStorageData,
} from '../firebaseStorage/actions'
import { updateCurrentConfig } from '../shareWheel/actions'
import { replaceCDN, isString } from '../../utils'
// import { removeObjectField } from '../../utils'

// import { displaySuccessModal } from '../modal/actions'
import {
  updateMysterySettings as updateMysterySettingsRNG,
  setScores as setScoresRNG,
  setAutoAddCount as setAutoAddCountRNG,
} from '../rng/actions'
import {
  updateMysterySettings as updateMysterySettingsYNW,
  clearResults as clearResultsYNW,
} from '../ynw/actions'
import {
  updateMysterySettings as updateMysterySettingsRLG,
  setScores as setScoresRLG,
  setAutoAddCount as setAutoAddCountRLG,
} from '../rlg/actions'
import {
  updateMysterySettings as updateMysterySettingsRCG,
  setScores as setScoresRCG,
  setAutoAddCount as setAutoAddCountRCG,
} from '../rcg/actions'
import {
  updateMysterySettings as updateMysterySettingsRSG,
  setScores as setScoresRSG,
  setAutoAddCount as setAutoAddCountRSG,
} from '../rsg/actions'
import {
  updateMysterySettings as updateMysterySettingsNFL,
  setScores as setScoresNFL,
  setAutoAddCount as setAutoAddCountNFL,
} from '../nfl/actions'
import {
  updateMysterySettings as updateMysterySettingsNBA,
  setScores as setScoresNBA,
  setAutoAddCount as setAutoAddCountNBA,
} from '../nba/actions'
import {
  updateMysterySettings as updateMysterySettingsMLB,
  setScores as setScoresMLB,
  setAutoAddCount as setAutoAddCountMLB,
} from '../mlb/actions'
import {
  updateMysterySettings as updateMysterySettingsRDG,
  setScores as setScoresRDG,
  setAutoAddCount as setAutoAddCountRDG,
} from '../rdg/actions'
import {
  updateMysterySettings as updateMysterySettingsCFQ,
  setScores as setScoresCFQ,
  setAutoAddCount as setAutoAddCountCFQ,
} from '../cfq/actions'
import {
  updateMysterySettings as updateMysterySettingsRCW,
  setScores as setScoresRCW,
  setAutoAddCount as setAutoAddCountRCW,
} from '../rcw/actions'
import {
  updateMysterySettings as updateMysterySettingsTDQ,
  setScores as setScoresTDQ,
  setAutoAddCount as setAutoAddCountTDQ,
} from '../tdq/actions'
import { numberToAlphabet } from '../../utils'
import { validateImageLimit } from '../../utils/validationUtil'
import { resetSpinQuantity } from '../turntable/actions'

const mysteryObjAction = {
  main: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsMain(mysteryWheelOn, mysteryResultOn)),
  rng: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRNG(mysteryWheelOn, mysteryResultOn)),
  rig: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRIG(mysteryWheelOn, mysteryResultOn)),
  ynw: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsYNW(mysteryWheelOn, mysteryResultOn)),
  rlg: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRLG(mysteryWheelOn, mysteryResultOn)),
  rcg: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRCG(mysteryWheelOn, mysteryResultOn)),
  rsg: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRSG(mysteryWheelOn, mysteryResultOn)),
  nfl: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsNFL(mysteryWheelOn, mysteryResultOn)),
  nba: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsNBA(mysteryWheelOn, mysteryResultOn)),
  mlb: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsMLB(mysteryWheelOn, mysteryResultOn)),
  rdg: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRDG(mysteryWheelOn, mysteryResultOn)),
  cfq: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsCFQ(mysteryWheelOn, mysteryResultOn)),
  rcw: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsRCW(mysteryWheelOn, mysteryResultOn)),
  tdq: (mysteryWheelOn, mysteryResultOn, dispatch) =>
    dispatch(updateMysterySettingsTDQ(mysteryWheelOn, mysteryResultOn)),
}

const scoresAction = {
  main: (scores, dispatch) => dispatch(setScoresMain(scores, 'Unchanged')),
  rng: (scores, dispatch) => dispatch(setScoresRNG(scores, 'Unchanged')),
  rig: (scores, dispatch) => dispatch(setScoresRIG(scores, 'Unchanged')),
  rlg: (scores, dispatch) => dispatch(setScoresRLG(scores, 'Unchanged')),
  rcg: (scores, dispatch) => dispatch(setScoresRCG(scores, 'Unchanged')),
  rsg: (scores, dispatch) => dispatch(setScoresRSG(scores, 'Unchanged')),
  nfl: (scores, dispatch) => dispatch(setScoresNFL(scores, 'Unchanged')),
  nba: (scores, dispatch) => dispatch(setScoresNBA(scores, 'Unchanged')),
  mlb: (scores, dispatch) => dispatch(setScoresMLB(scores, 'Unchanged')),
  rdg: (scores, dispatch) => dispatch(setScoresRDG(scores, 'Unchanged')),
  cfq: (scores, dispatch) => dispatch(setScoresCFQ(scores, 'Unchanged')),
  rcw: (scores, dispatch) => dispatch(setScoresRCW(scores, 'Unchanged')),
  tdq: (scores, dispatch) => dispatch(setScoresTDQ(scores, 'Unchanged')),
}

const autoAddCountAction = {
  main: (autoAddCount, dispatch) => dispatch(setAutoAddCountMain(autoAddCount)),
  rng: (autoAddCount, dispatch) => dispatch(setAutoAddCountRNG(autoAddCount)),
  rig: (autoAddCount, dispatch) => dispatch(setAutoAddCountRIG(autoAddCount)),
  rlg: (autoAddCount, dispatch) => dispatch(setAutoAddCountRLG(autoAddCount)),
  rcg: (autoAddCount, dispatch) => dispatch(setAutoAddCountRCG(autoAddCount)),
  rsg: (autoAddCount, dispatch) => dispatch(setAutoAddCountRSG(autoAddCount)),
  nfl: (autoAddCount, dispatch) => dispatch(setAutoAddCountNFL(autoAddCount)),
  nba: (autoAddCount, dispatch) => dispatch(setAutoAddCountNBA(autoAddCount)),
  mlb: (autoAddCount, dispatch) => dispatch(setAutoAddCountMLB(autoAddCount)),
  rdg: (autoAddCount, dispatch) => dispatch(setAutoAddCountRDG(autoAddCount)),
  cfq: (autoAddCount, dispatch) => dispatch(setAutoAddCountCFQ(autoAddCount)),
  rcw: (autoAddCount, dispatch) => dispatch(setAutoAddCountRCW(autoAddCount)),
  tdq: (autoAddCount, dispatch) => dispatch(setAutoAddCountTDQ(autoAddCount)),
}

const choiceHDImagesAction = {
  main: (choiceHDImages, dispatch) =>
    dispatch(setChoiceHDImagesMain(choiceHDImages)),
  rig: (choiceHDImages, dispatch) =>
    dispatch(setChoiceHDImagesRIG(choiceHDImages)),
}

export const setUserProfileData = async user => {
  // const firebaseApp = getFirebase()
  // const firestore = firebase.firestore()
  // const d = collection(firestore, 'users').doc(user.uid)
  const d = doc(firestore, 'users', user.uid)
  return await setDoc(d, {
    displayName: user.displayName,
    email: user.email,
    photoURL: user.photoURL || '',
    role: 'subscriber',
    gender: '',
    occupation: '',
    country: '',
    uid: user.uid,
    providerId: user.providerData[0].providerId, //no longer for many use, this is the user first providerid, only for increment and decrement user
    createdAt: serverTimestamp(),
    lastActive: serverTimestamp(),
  })
}

// export const updateUserProfile = profile => async (dispatch, getState) => {
//   // const firebaseApp = getFirebase()
//   const user = auth.currentUser
//   const firestore = getFirestore()
//   // const firestore = firebase.firestore()
//   try {
//     dispatch(asyncActionStart('loadingButton'))
//     if (user.displayName !== profile.displayName) {
//       await updateProfile(user, {
//         displayName: profile.displayName,
//       })
//     }
//     // const d = collection(firestore, 'users').doc(user.uid)
//     const d = doc(firestore, 'users', user.uid)
//     await updateDoc(d, profile)
//     dispatch(asyncActionFinish('loadingButton'))
//   } catch (error) {
//     dispatch(asyncActionError('loadingButton'))
//     throw error
//   }
// }

export const updateLastActive = async user => {
  // const firestore = firebase.firestore()
  // const firebaseApp = getFirebase()
  // const d = collection(firestore, 'users').doc(user.uid)
  const d = doc(firestore, 'users', user.uid)
  return await updateDoc(d, {
    lastActive: serverTimestamp(),
  })
  // return await firestore
  //   .collection('users')
  //   .doc(user.uid)
  //   .update({
  //     lastActive: firebase.firestore.FieldValue.serverTimestamp(),
  //   })
}

// export const updateUserProfilePhoto = async downloadURL => {
//   // const firebaseApp = getFirebase()
//   const user = auth.currentUser
//   const firestore = getFirestore()
//   // const firestore = firebase.firestore()
//   // const userDocRef = collection(firestore, 'users').doc(user.uid)
//   const userDocRef = doc(firestore, 'users', user.uid)
//   try {
//     const userDoc = await getDoc(userDocRef)
//     if (userDoc.exists()) {
//       if (userDoc.data().photoURL !== downloadURL) {
//         // const d = collection(firestore, 'users').doc(user.uid)
//         await updateDoc(userDocRef, {
//           photoURL: downloadURL,
//         })
//         await updateProfile(user, {
//           photoURL: downloadURL,
//         })
//       }
//     }
//   } catch (error) {
//     throw error
//   }
// }

export const getUserProfile = async () => {
  // const firebaseApp = getFirebase()
  const user = auth.currentUser
  // const firestore = firebase.firestore()
  const userDocRef = doc(firestore, 'users', user.uid)
  return await getDoc(userDocRef)
}

export const getLoadListsNames = async () => {
  // const firebaseApp = getFirebase()
  try {
    const user = auth.currentUser
    const saveListNamesColRef = collection(
      firestore,
      'users',
      user.uid,
      'save-lists-names',
    )
    // const listNamesQuery = query(
    //   saveListNamesColRef,
    //   // orderBy(documentId()), // Ascending order is default, to ensure getting "all" doc, but make sure "all" is the first document
    //   limit(1),
    // )
    const saveListNamesCol = await getDocs(saveListNamesColRef)
    // console.log({ saveListNamesCol })
    if (saveListNamesCol.metadata.fromCache) {
      if (!navigator.onLine) {
        throw new Error('Device is offline. Check your network.')
      } else {
        throw new Error('Server unreachable. Check your network/firewall.')
      }
    }
    if (saveListNamesCol.empty) {
      // No saved files before
      return {}
    } else {
      let namesDataDb
      if (saveListNamesCol.size === 1) {
        saveListNamesCol.forEach(doc => {
          if (doc.id === 'all') {
            //ideal case: using new "all" doc, "all" should be the first doc
            namesDataDb = doc.data()
          }
        })
        if (namesDataDb) return namesDataDb
      }

      //if size more than 1 || the single doc is not "all"
      let allNamesData = {}
      let allKeyExist = false
      const batch = writeBatch(firestore)
      saveListNamesCol.forEach(doc => {
        if (doc.id === 'all') {
          //precaution step for the docs contain "all", this shouldnt happen
          allNamesData = doc.data()
          allKeyExist = true
        }
        if (!allKeyExist) {
          const pageFileNames = doc.data()
          const fileKeys = Object.keys(pageFileNames)
          const premiumFileKeys = fileKeys.filter(key => key.includes('PER'))
          if (premiumFileKeys.length === 0) {
            allNamesData[doc.id] = pageFileNames
          } else {
            //refactor PER1 to alphabets
            premiumFileKeys.map(currentKey => {
              const newKey = numberToAlphabet(
                parseInt(currentKey.substring(3)) + 15,
              ) // start from 16 (P)
              pageFileNames[currentKey] = {
                ...pageFileNames[currentKey],
                newFileId: newKey,
              }
            })
            allNamesData[doc.id] = pageFileNames
          }
        }

        if (doc.id !== 'all') {
          batch.delete(doc.ref)
        }
      })
      const allFileNamesRef = doc(saveListNamesColRef, 'all')
      batch.set(allFileNamesRef, allNamesData)

      await batch.commit()
      namesDataDb = allNamesData
      return namesDataDb
    }
  } catch (error) {
    throw error
  }
}

export const getLoadList =
  (page, selectedList) => async (dispatch, getState) => {
    // dispatch(asyncActionStart('loadingButton'))
    dispatch(setIsReadingFile(true))
    const state = getState()
    let loadFromCloud = false
    try {
      let savedList = null
      // when hasStorage key is true, direct open from firebase
      if (!selectedList.hasStorage && (page === 'main' || page === 'rig')) {
        if (state[page].savedChoicesList.hasOwnProperty(selectedList.id)) {
          savedList = cloneDeep(state[page].savedChoicesList[selectedList.id]) // clone deep needed else local save list will also change value based on reference
        }
      } else if (page === 'rtg' && !selectedList.isCollectShareMethod) {
        if (state.rtg.savedPeopleList.hasOwnProperty(selectedList.id)) {
          savedList = cloneDeep(state.rtg.savedPeopleList[selectedList.id])
        }
      }
      let listData = null
      if (
        savedList !== null &&
        savedList?.uniqueId !== null &&
        savedList?.uniqueId === selectedList.uniqueId
      ) {
        //if there is same uniqueid, load from local storage

        listData = {
          ...selectedList,
          ...savedList,
        }

        if (!savedList.title) {
          listData['title'] = {
            active: false,
            text: '',
            description: '',
            popup: '',
          }
        } else {
          listData.title = refactorTitle(listData.title)
        }
        if (page === 'rtg') {
          dispatch(setFreezeEditing(false))
        }
        // if (page !== 'rtg') {
        //   listData['choices'] = savedList.choices
        // } else {
        //   listData['people'] = savedList.people
        // }
        // if (savedList['settings']) {
        //   listData['settings'] = savedList['settings']
        // }
      } else {
        // const firebaseApp = getFirebase()
        const user = auth.currentUser
        // const firestore = firebase.firestore()
        const userDocRef = doc(firestore, 'users', user.uid)
        const d = doc(userDocRef, `save-lists-${page}`, selectedList.id)

        const promises = []
        promises.push(getDoc(d))

        if (selectedList.hasStorage) {
          // promises.push(
          //   copyStorageData(
          //     `users/${user.uid}/save-lists-${page}/${selectedList.id}`,
          //   ),
          // )
          // const storageRef = ref(
          //   storage,
          //   `users/${user.uid}/save-lists-${page}/${selectedList.id}`,
          // )
          // promises.push(getDownloadURL(storageRef))
          promises.push(getR2StorageData(page, selectedList.id))
          // promises.push(getStorageData(page, selectedList.id))
        } else if (page === 'rtg' && selectedList.isCollectShareMethod) {
          const selfJoinResultDoc = doc(
            d,
            'collectResults',
            `${selectedList.sharePath}-results`,
          )
          promises.push(getDoc(selfJoinResultDoc))
        }

        const promiseResults = await Promise.all(promises)

        const list = promiseResults[0]

        // const list = await getDoc(d)
        if (!list.exists()) {
          // dispatch(asyncActionFinish('loadingButton'))
          return true
        }
        loadFromCloud = true
        listData = list.data()
        if (!listData.title) {
          listData['title'] = {
            active: false,
            text: '',
            description: '',
            popup: '',
          }
        } else {
          listData.title = refactorTitle(listData.title)
        }

        if (selectedList.hasStorage) {
          listData['hasStorage'] = true
          // const storageData = promiseResults[1].data.data
          const storageData = promiseResults[1]
          // const url = promiseResults[1]
          // const res = await fetch(url)
          // const storageData = JSON.parse(await res.text())
          listData = { ...listData, ...storageData }
        } else if (page === 'rtg' && selectedList.isCollectShareMethod) {
          const resultDoc = promiseResults[1]
          const selfJoinResult = resultDoc.data()
          const { groups, people, representativeIndexes } = selfJoinGrouping(
            selfJoinResult.array,
            +listData.numGroups,
            listData.evenSplit,
            listData.pickRepresentative,
          )
          const csvGroups = csvGrouping(
            groups,
            listData.groupNames,
            listData.evenSplit,
            representativeIndexes,
          )
          listData['selfJoinPeople'] = people
          listData['groups'] = groups
          listData['csvGroups'] = csvGroups
          listData['representativeIndexes'] = representativeIndexes
          if (!listData['groupSizes']) {
            const tempGroupSizes = listData.wheelChoices.map(choice => {
              return choice.number
            })
            listData['groupSizes'] = tempGroupSizes
          }

          dispatch(setFreezeEditing(true))
        }
      }

      if (page === 'main') {
        const isTextMode = state[page].inputEditMode === 'Text'
        let hasSpecialKeys = false
        //refactor input.name image to input.data
        for (let input of listData.choices) {
          if (isImageData(input.name)) {
            input['data'] = input.name
            input.name = ''
          }
          if (
            isTextMode &&
            !hasSpecialKeys &&
            ('color' in input || 'headline' in input)
          ) {
            hasSpecialKeys = true
          }
          delete input.count
        }
        if (hasSpecialKeys) {
          // if have label/color, then change from Text mode to Main mode
          dispatch(setInputEditMode('Main'))
        }

        // for old files, make sure have headlineOn and colorOn keys
        ;['headlineOn', 'colorOn'].forEach(key => {
          if (!(key in listData)) listData[key] = false
        })

        // show all enabled weight/label/color, don't hide them in input list
        const inputShowMode = [
          ...(listData.weightOn ? ['Weight'] : []),
          ...(listData.headlineOn ? ['Label'] : []),
          'Input',
          ...(listData.colorOn ? ['Color'] : []),
        ]
        dispatch(setInputShowMode(inputShowMode))
        dispatch(
          setChoiceHDImagesMain(
            listData.choiceHDImages ? listData.choiceHDImages : [],
          ),
        )
      } else if (page === 'rtg') {
        if (listData.groups && isString(listData.groups)) {
          //load from local maybe not string
          listData.groups = JSON.parse(listData.groups)
        }
        if (listData.csvGroups && isString(listData.csvGroups)) {
          //load from local maybe not string
          listData.csvGroups = JSON.parse(listData.csvGroups)
        }
        if (!listData.presetGroups) {
          listData.presetGroups = []
        } else if (listData.presetGroups && isString(listData.presetGroups)) {
          //load from local maybe not string
          listData.presetGroups = JSON.parse(listData.presetGroups)
        }

        if (!selectedList.isCollectShareMethod) {
          if (!listData['groupSizes']) {
            const tempGroupSizes = listData.groups.map(group => {
              return group.length
            })
            listData['groupSizes'] = tempGroupSizes
          }
          dispatch(setFreezeEditing(false))
        }
      } else if (page === 'rng') {
        if (listData.digitRanges && isString(listData.digitRanges)) {
          listData.digitRanges = JSON.parse(listData.digitRanges)
        }
      } else if (page === 'rig') {
        listData.choices = listData.choices.map(({ count, ...rest }) => rest)
        dispatch(
          setChoiceHDImagesRIG(
            listData.choiceHDImages ? listData.choiceHDImages : [],
          ),
        )
      } else if (page === 'ynw') {
        dispatch(clearResultsYNW())
      }
      //clear history
      if (page !== 'rtg') {
        listData['history'] = []
        dispatch(resetSpinQuantity())
      }
      const { id, name, settings, ...newStateData } = listData
      const loadedData =
        page !== 'rtg'
          ? { ...newStateData, turnTable: null }
          : { ...newStateData }
      dispatch({
        type: `REPLACE_STATE_${page.toUpperCase()}`,
        payload: {
          data: loadedData,
        },
      })
      // when hasStorage key is true, prevent store to localstorage
      if (!selectedList.hasStorage) {
        switch (page) {
          case 'main':
            if (loadFromCloud)
              dispatch(saveLocalChoicesList(cloneDeep(listData))) //save to local storage if retrieve from cloud
            break
          case 'rtg':
            if (loadFromCloud && !selectedList.isCollectShareMethod)
              dispatch(saveLocalPeopleList(cloneDeep(listData)))
            break
          case 'rig':
            if (loadFromCloud)
              dispatch(saveLocalChoicesListRIG(cloneDeep(listData)))
            break
        }
      }
      dispatch(setCurrentFileKey(id))
      dispatch(setDataStatus('Unchanged'))
      if (newStateData.sharePath) {
        dispatch(
          updateCurrentConfig({
            shareMethod: selectedList.isCollectShareMethod ? 'Collect' : 'File',
            fileSharePath: newStateData.sharePath,
            isPrivate: selectedList.isPrivate || false, // default is false
            shareCanEdit: newStateData.websiteMode === 'ShareCanEdit',
          }),
        )
      } else {
        dispatch(updateCurrentConfig(null))
      }
      dispatch(setCurrentTabData(listData))
      let mysterySpin = false
      if (settings) {
        const refactoredMusic = refactorSoundSettings(settings.music)
        const refactoredBehavior = refactorSpinBehavior(settings.spinBehavior)
        const refactoredToolBackground = refactorToolBackgroundSettings(
          settings.toolBgTransparency,
        )

        if (refactoredBehavior.mysterySpin !== undefined) {
          mysterySpin = refactoredBehavior.mysterySpin
          delete refactoredBehavior.mysterySpin
        }

        const updatedSettings = {
          ...settings,
          music: refactoredMusic,
          spinBehavior: refactoredBehavior,
          toolBgTransparency: refactoredToolBackground.toolBgTransparency,
        }
        if (!updatedSettings.rtgSpinBehavior) {
          //add new rtg behavior
          updatedSettings['rtgSpinBehavior'] = {
            groupingDuration: 5,
            representativeDuration: 3,
          }
        }
        dispatch(setToolSettingsActiveIndex(1))
        await dispatch(updateAllSettings(updatedSettings, page))
        if (
          !state.auth.currentUser?.isPremium &&
          (settings.banners?.on ||
            settings.bgImage?.on ||
            settings.spinButton?.colorOn ||
            settings.spinButton?.imageOn ||
            settings.music?.customOn ||
            (settings.imageDisplaySize || '200') !== '200')
        ) {
          // for premium to non-premium users
          dispatch(turnOffPremiumSettings())
        }
      }

      const {
        mysteryWheelOn = mysterySpin, // old version settings.spinBehavior.mysterySpin, changed to mysteryWheelOn in each tools
        mysteryResultOn = false,
        scores = [],
      } = listData
      if (page !== 'rtg') {
        //rtg dont have mystery and score
        mysteryObjAction[page](mysteryWheelOn, mysteryResultOn, dispatch)
        if (page !== 'ynw') {
          //ynw has different score structure
          const finalScores = Array.isArray(scores) ? scores : []
          scoresAction[page](finalScores, dispatch) // to fix issue when scores value is { _methodName: 'deleteField' }
          autoAddCountAction[page](finalScores.length > 0, dispatch)
        }
      }

      // dispatch(asyncActionFinish('loadingButton'))
      dispatch(setIsReadingFile(false))
      return true
    } catch (error) {
      dispatch(setIsReadingFile(false))
      // dispatch(asyncActionError('loadingButton'))
      throw error
    }
  }

export const setSaveList =
  (
    page,
    listId,
    name,
    settingsChecked,
    resetShareConfig,
    prevHasStorage,
    prevHasCloudflare,
    userRole,
  ) =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsReadingFile(true))
      const state = getState()
      const pageSupportsStorage = page === 'main' || page === 'rig'
      if (pageSupportsStorage) {
        const error = validateImageLimit(
          userRole,
          state[page].choices,
          state[page].choiceHDImages,
        )
        if (error) {
          return { error }
        }
      }

      // dispatch(asyncActionStart('loadingButton'))
      // const firebaseApp = getFirebase()
      const user = auth.currentUser
      // const firestore = firebase.firestore()
      const batch = writeBatch(firestore)
      // const state = getState()

      const userDocRef = doc(firestore, 'users', user.uid)

      const namesPath = doc(userDocRef, `save-lists-names`, 'all')

      const uniqueId = cuid()

      // const listNamesExist = listNames !== null

      const nameObject = {
        [page]: {
          [listId]: {
            name: name,
            id: listId,
            uniqueId: uniqueId,
          },
        },
      }
      if (settingsChecked) {
        nameObject[page][listId]['settingsChecked'] = true
      }
      // if (!isReplacingSameFile) {
      //   //global share link exits, then add sharePath
      //   nameObject[listId]['sharePath'] = deleteField()
      // }
      // if (listNamesExist) {
      //   batch.update(namesPath, nameObject)

      //   const isReplacingShareLink = !!listNames[listId]?.sharePath
      //   if (isReplacingShareLink) {
      //     //replacing an old share link
      //     const oldSharePath = listNames?.[listId]?.sharePath
      //     const linkDocRef = doc(
      //       firestore,
      //       'share-wheels',
      //       page,
      //       'share-links',
      //       oldShareId,
      //     )
      //     batch.update(linkDocRef, {
      //       hasOwner: false,
      //       lastUpdated: serverTimestamp(),
      //     })
      //   }
      // } else {
      // if the collection does not exist
      // batch.set(namesPath, nameObject, { merge: true })
      // }

      let data
      // if (!sharePath) {
      const fSettings = state.settings
      const dataPath = doc(userDocRef, `save-lists-${page}`, listId)
      data = {
        createdDate: serverTimestamp(),
        name: name,
        id: listId,
        uniqueId: uniqueId,
      }
      if (page === 'main') {
        data['choices'] = state[page].choices
        data['weightOn'] = state[page].weightOn
        data['headlineOn'] = state[page].headlineOn
        data['colorOn'] = state[page].colorOn
        data['mode'] = state[page].mode
        // if (weightOn) {
        //   data['weightOn'] = weightOn
        // } else {
        //   if (isReplacingSameFile) {
        //     data['weightOn'] = deleteField()
        //   }
        // }
      } else if (page === 'rtg') {
        const groupMethod = state[page].groupMethod
        data['groupMethod'] = groupMethod
        if (groupMethod === 'host') {
          data['people'] = state[page].people
        }
        data['groupNames'] = state[page].groupNames
        data['numGroups'] = state[page].numGroups
        data['evenSplit'] = state[page].evenSplit
        data['showIcon'] = state[page].showIcon
        data['pickQuantity'] = state[page].pickQuantity
        data['groups'] = JSON.stringify(state[page].groups)
        data['csvGroups'] = JSON.stringify(state[page].csvGroups)
        data['representativeIndexes'] = state[page].representativeIndexes
        data['pickRepresentative'] = state[page].pickRepresentative
        data['presetGroups'] = JSON.stringify(state[page].presetGroups)
        data['selfJoinSettings'] = state[page].selfJoinSettings
        data['differentSplit'] = state[page].differentSplit
        data['groupSizes'] = state[page].groupSizes
      } else if (page === 'rig') {
        data['choices'] = state[page].choices
        data['mode'] = state[page].mode
      } else if (page === 'rng') {
        const {
          choices,
          typeOption,
          autoSpinMerge,
          minValue,
          maxValue,
          intervalValue,
          excludeFieldValue,
          formulaFieldValue,
          inputMethod,
          digitRanges,
          digitNumber,
          // resultsArray,
        } = state[page]
        data = {
          ...data,
          choices,
          typeOption,
          autoSpinMerge,
          minValue,
          maxValue,
          intervalValue,
          excludeFieldValue,
          formulaFieldValue,
          inputMethod,
          digitRanges: JSON.stringify(digitRanges),
          digitNumber,
          resultsArray: new Array(digitNumber).fill(null),
        }
      } else if (page === 'ynw') {
        const { inputMode, numInputSet } = state[page]
        data = {
          ...data,
          inputMode,
          numInputSet,
        }
      } else if (page === 'rlg') {
        const { choices, inputMode, styleMode, customInput } = state[page]
        data = {
          ...data,
          choices,
          inputMode,
          styleMode,
          customInput,
        }
      } else if (page === 'rcg' || page === 'cfq') {
        const { choices, continentsActive, showMode } = state[page]
        data = {
          ...data,
          choices,
          continentsActive,
          showMode,
        }
        if (page === 'cfq')
          data['answerChoiceCount'] = state[page].answerChoiceCount
      } else if (page === 'rsg') {
        const { choices, countryActive, showMode } = state[page]
        data = {
          ...data,
          choices,
          countryActive,
          showMode,
        }
      } else if (page === 'nfl' || page === 'nba' || page === 'mlb') {
        const { choices, conferenceActive, teamsActive, showMode } = state[page]
        data = {
          ...data,
          choices,
          conferenceActive,
          teamsActive,
          showMode,
        }
      } else if (page === 'rdg') {
        const { choices, inputMode, daysMode, inputs } = state[page]
        data = {
          ...data,
          choices,
          inputMode,
          daysMode,
          inputs,
        }
      } else if (page === 'rcw') {
        const {
          choices,
          mode,
          showMode,
          inputMethod,
          colorWheel,
          // colorSchemeSelected,
          // paletteWheel,
          // primaryColor,
        } = state[page]
        data = {
          ...data,
          choices,
          mode,
          showMode,
          inputMethod,
          colorWheel,
          // colorSchemeSelected,
          // paletteWheel,
          // primaryColor,
        }
      } else if (page === 'tdq') {
        const { choices, typeActive, typeCount, category, level } = state[page]
        data = {
          ...data,
          choices,
          typeActive,
          typeCount,
          category,
          level,
        }
      }
      if (page !== 'rtg') {
        //rtg dont have mystery and score
        data['mysteryWheelOn'] = state[page].mysteryWheelOn
        data['mysteryResultOn'] = state[page].mysteryResultOn

        if (page !== 'ynw') {
          // ynw has its own score structure
          const scores = state[page].scores
          if (scores.length > 0) {
            data['scores'] = scores
          } else {
            const { scores, ...dataWithoutScores } = data
            data = dataWithoutScores
          }
        }
      }

      const toolTitle = state[page].title
      if (toolTitle.active) {
        data['title'] = toolTitle
      } else {
        data['title'] = {
          active: false,
          text: '',
          description: '',
          popup: '',
        }
      }

      if (settingsChecked) {
        const results = await copyAssets(fSettings, listId, user.uid, page)
        let settingsData = { ...fSettings }
        if (settingsData.hasOwnProperty('_persist')) {
          delete settingsData._persist
        }
        if (Object.keys(results).length > 0) {
          // has new src urls
          settingsData = await replaceNewSettings(results, settingsData)
          dispatch(updateAllSettings(settingsData, page))
          dispatch(setToolSettingsActiveIndex(1))
        }
        data['settings'] = settingsData
        // } else {
        //   if (isReplacingSameFile) {
        //     data['settings'] = deleteField()
        //   }
      }

      const promises = []
      let dataToSet = { ...data }
      const dataLength = JSON.stringify({ ...data }).length
      // console.log(dataLength)
      if (
        dataLength > 990000 &&
        (!state.auth.currentUser?.isPremium || !pageSupportsStorage)
      ) {
        return {
          error: 'Too many images/inputs, reduce some and try again.',
        }
      }

      let finalChoiceHDImages = []
      if (pageSupportsStorage) {
        const currentFileKey = state.common.currentFileKey
        const isCurrentFile = currentFileKey === listId
        const choiceHDImages = state[page]?.choiceHDImages || []
        if (choiceHDImages.length > 0) {
          // upload and delete cloudflare images
          finalChoiceHDImages = await processChoiceHDImages(
            choiceHDImages,
            data.choices,
            page,
            listId,
          )
          if (finalChoiceHDImages.length > 0) {
            nameObject[page][listId]['hasCloudflare'] = true
            data['hasCloudflare'] = true
            data['choiceHDImages'] = finalChoiceHDImages
            dataToSet['choiceHDImages'] = finalChoiceHDImages
            if (prevHasCloudflare && !isCurrentFile) {
              // clean up unused cloudflare images
              promises.push(
                cleanupFolderFromR2(
                  page,
                  listId,
                  finalChoiceHDImages.map(item => item.filename),
                ),
              )
            }
          } else if (prevHasCloudflare) {
            nameObject[page][listId]['hasCloudflare'] = deleteField()
            if (!isCurrentFile) {
              // delete all cloudflare images
              promises.push(deleteFolderFromR2(page, listId))
            }
          }
          choiceHDImagesAction[page](finalChoiceHDImages, dispatch)
        } else if (prevHasCloudflare) {
          nameObject[page][listId]['hasCloudflare'] = deleteField()
          if (!isCurrentFile) {
            // delete all cloudflare images
            promises.push(deleteFolderFromR2(page, listId))
          }
        }
      }

      if (dataLength > 990000) {
        // dispatch(asyncActionError('loadingButton'))
        // if (!state.auth.currentUser?.isPremium || !pageSupportsStorage) {
        //   return {
        //     error: 'Too many images/inputs, reduce some and try again.',
        //   }
        // } else {
        const storageData = {
          choices: data.choices,
          ...(finalChoiceHDImages.length > 0 && {
            choiceHDImages: finalChoiceHDImages,
          }),
        }
        promises.push(saveListDataToR2(page, listId, storageData))
        // const storageRef = ref(storage, storagePath)
        // promises.push(uploadString(storageRef, JSON.stringify(storageData)))

        nameObject[page][listId]['hasStorage'] = true
        const keyName = page === 'rtg' ? 'people' : 'choices'
        const {
          [keyName]: removed,
          hasCloudflare: removed2,
          choiceHDImages: removed3,
          ...newData
        } = data
        dataToSet = newData
        data['hasStorage'] = true
        // }
      } else if (pageSupportsStorage && prevHasStorage) {
        nameObject[page][listId]['hasStorage'] = deleteField()
        promises.push(deleteR2StorageData(page, listId))
        // promises.push(deleteUserAsset(`save-lists-${page}`, listId))
      }
      batch.set(namesPath, nameObject, { merge: true })
      batch.set(dataPath, dataToSet)
      // }

      // await batch.commit()
      promises.push(batch.commit())
      await Promise.all(promises)

      // if (shareId) {
      //   const addOwnerShareWheel = httpsCallable(
      //     functions,
      //     'addOwnerShareWheel',
      //   )
      //   const result = await addOwnerShareWheel({
      //     page,
      //     path: shareId,
      //     uid: user.uid,
      //   })
      //   const data = result.data
      //   if (data.error) {
      //     console.log(data.error)
      //     // dispatch(asyncActionError('share'))
      //     throw {
      //       error: 'Error when saving the link, please try again.',
      //     }
      //   }
      //   return {
      //     error: '',
      //   }
      // }
      //if have shareId will not go next steps
      dispatch(setCurrentFileKey(listId))
      dispatch(setDataStatus('Unchanged'))
      // when hasStorage key is true, prevent store to localstorage
      if (!data.hasStorage) {
        switch (page) {
          case 'main':
            dispatch(saveLocalChoicesList(cloneDeep(data))) // clone deep needed else local save list will also change value based on reference, only save private save list not global share link
            break
          case 'rtg':
            dispatch(saveLocalPeopleList(cloneDeep(data)))
            break
          case 'rig':
            dispatch(saveLocalChoicesListRIG(cloneDeep(data)))
            break
        }
      }
      if (resetShareConfig) dispatch(updateCurrentConfig(null)) // shareSavelist dont reset, savelist reset
      dispatch(setCurrentTabData(data))
      dispatch(setIsReadingFile(false))
      return {
        error: '',
      }
    } catch (error) {
      // console.log(error.code)
      dispatch(setIsReadingFile(false))
      if (error.code === 'permission-denied') {
        checkRecoverUser()
      }
      // dispatch(asyncActionError('loadingButton'))
      throw error
    }
  }

export const instantSave = (page, userRole) => async (dispatch, getState) => {
  try {
    dispatch(setIsReadingFile(true))
    const state = getState()
    const pageSupportsStorage = page === 'main' || page === 'rig'
    if (pageSupportsStorage) {
      const error = validateImageLimit(
        userRole,
        state[page].choices,
        state[page].choiceHDImages,
      )
      if (error) {
        // return error
        if (error) {
          return { error }
        }
      }
    }

    // throw new Error('Too many images/inputs, reduce some and try again.')
    dispatch(setDataStatus('Saving'))
    const user = auth.currentUser
    const batch = writeBatch(firestore)
    // const state = getState()
    const listId = state.common.currentFileKey
    const settingsChecked = true
    const {
      name,
      hasStorage = false,
      hasCloudflare = false,
    } = state.common.tabsData[state.common.currentTabIndex]

    const { shareMethod, fileSharePath } = state.share.currentConfig

    const userDocRef = doc(firestore, 'users', user.uid)
    const namesPath = doc(userDocRef, `save-lists-names`, 'all')
    const dataPath = doc(userDocRef, `save-lists-${page}`, listId)

    const newUniqueId = cuid()

    const nameObject = {
      [page]: {
        [listId]: {
          name: name,
          id: listId,
          uniqueId: newUniqueId,
        },
      },
    }

    if (settingsChecked) {
      nameObject[page][listId]['settingsChecked'] = true
    }

    // batch.set(namesPath, nameObject, { merge: true })

    let data
    data = {
      updatedDate: serverTimestamp(),
      name: name,
      id: listId,
      uniqueId: newUniqueId,
      // [keyName]: page === 'rtg' ? state[page].people : state[page].choices,
    }
    if (page === 'main') {
      data['choices'] = state[page].choices
      data['weightOn'] = state[page].weightOn
      data['headlineOn'] = state[page].headlineOn
      data['colorOn'] = state[page].colorOn
      data['mode'] = state[page].mode
      // if (weightOn) {
      //   data['weightOn'] = weightOn
      //   // } else {
      //   //   data['weightOn'] = deleteField()
      // }
    } else if (page === 'rtg') {
      data['people'] = state[page].people
      data['groupNames'] = state[page].groupNames
      data['numGroups'] = state[page].numGroups
      data['evenSplit'] = state[page].evenSplit
      data['showIcon'] = state[page].showIcon
      data['pickQuantity'] = state[page].pickQuantity
      data['groups'] = JSON.stringify(state[page].groups)
      data['csvGroups'] = JSON.stringify(state[page].csvGroups)
      data['representativeIndexes'] = state[page].representativeIndexes
      data['pickRepresentative'] = state[page].pickRepresentative
      data['presetGroups'] = JSON.stringify(state[page].presetGroups)
      data['groupMethod'] = state[page].groupMethod
      data['selfJoinSettings'] = state[page].selfJoinSettings
      data['differentSplit'] = state[page].differentSplit
      data['groupSizes'] = state[page].groupSizes
    } else if (page === 'rig') {
      data['choices'] = state[page].choices
      data['mode'] = state[page].mode
    } else if (page === 'rng') {
      const {
        choices,
        typeOption,
        autoSpinMerge,
        minValue,
        maxValue,
        intervalValue,
        excludeFieldValue,
        formulaFieldValue,
        inputMethod,
        digitRanges,
        digitNumber,
        // resultsArray,
      } = state[page]
      data = {
        ...data,
        choices,
        typeOption,
        autoSpinMerge,
        minValue,
        maxValue,
        intervalValue,
        excludeFieldValue,
        formulaFieldValue,
        inputMethod,
        digitRanges: JSON.stringify(digitRanges),
        digitNumber,
        resultsArray: new Array(digitNumber).fill(null),
      }
    } else if (page === 'ynw') {
      const { inputMode, numInputSet } = state[page]
      data = {
        ...data,
        inputMode,
        numInputSet,
      }
    } else if (page === 'rlg') {
      const { choices, inputMode, styleMode, customInput } = state[page]
      data = {
        ...data,
        choices,
        inputMode,
        styleMode,
        customInput,
      }
    } else if (page === 'rcg' || page === 'cfq') {
      const { choices, continentsActive, showMode } = state[page]
      data = {
        ...data,
        choices,
        continentsActive,
        showMode,
      }
      if (page === 'cfq')
        data['answerChoiceCount'] = state[page].answerChoiceCount
    } else if (page === 'rsg') {
      const { choices, countryActive, showMode } = state[page]
      data = {
        ...data,
        choices,
        countryActive,
        showMode,
      }
    } else if (page === 'nfl' || page === 'nba' || page === 'mlb') {
      const { choices, conferenceActive, teamsActive, showMode } = state[page]
      data = {
        ...data,
        choices,
        conferenceActive,
        teamsActive,
        showMode,
      }
    } else if (page === 'rdg') {
      const { choices, inputMode, daysMode, inputs } = state[page]
      data = {
        ...data,
        choices,
        inputMode,
        daysMode,
        inputs,
      }
    } else if (page === 'rcw') {
      const {
        choices,
        mode,
        showMode,
        inputMethod,
        colorWheel,
        // colorSchemeSelected,
        // paletteWheel,
        // primaryColor,
      } = state[page]
      data = {
        ...data,
        choices,
        mode,
        showMode,
        inputMethod,
        colorWheel,
        // colorSchemeSelected,
        // paletteWheel,
        // primaryColor,
      }
    } else if (page === 'tdq') {
      const { choices, typeActive, typeCount, category, level } = state[page]
      data = {
        ...data,
        choices,
        typeActive,
        typeCount,
        category,
        level,
      }
    }

    if (page !== 'rtg') {
      //rtg dont have mystery and score
      data['mysteryWheelOn'] = state[page].mysteryWheelOn
      data['mysteryResultOn'] = state[page].mysteryResultOn

      if (page !== 'ynw') {
        // ynw has its own score structure
        const scores = state[page].scores
        if (scores.length > 0) {
          data['scores'] = scores
        } else {
          data['scores'] = deleteField()
        }
      }
    }

    const toolTitle = state[page].title
    if (toolTitle.active) {
      data['title'] = toolTitle
    } else {
      data['title'] = { active: false, text: '', description: '', popup: '' }
    }

    if (settingsChecked) {
      const fSettings = state.settings
      const results = await copyAssets(fSettings, listId, user.uid, page)
      let settingsData = { ...fSettings }
      if (settingsData.hasOwnProperty('_persist')) {
        delete settingsData._persist
      }
      if (Object.keys(results).length > 0) {
        // has new src urls
        settingsData = await replaceNewSettings(results, settingsData)
        dispatch(updateAllSettings(settingsData, page))
        dispatch(setToolSettingsActiveIndex(1))
      }
      data['settings'] = settingsData
    }

    // const fileShareConfig = state.share.fileShareConfig
    // if (fileShareConfig) {
    //   data = {
    //     ...data,
    //     ...fileShareConfig,
    //   }
    // }

    const promises = []
    let dataToSet = { ...data }
    const dataLength = JSON.stringify({ ...data }).length
    if (
      dataLength > 990000 &&
      (!state.auth.currentUser?.isPremium || !pageSupportsStorage)
    ) {
      return {
        error: 'Too many images/inputs, reduce some and try again.',
      }
    }

    let finalChoiceHDImages = []
    if (pageSupportsStorage) {
      const prevHasCloudflare = hasCloudflare
      const choiceHDImages = state[page]?.choiceHDImages || []
      if (choiceHDImages.length > 0) {
        // upload and delete cloudflare images
        finalChoiceHDImages = await processChoiceHDImages(
          choiceHDImages,
          data.choices,
          page,
          listId,
        )
        if (finalChoiceHDImages.length > 0) {
          nameObject[page][listId]['hasCloudflare'] = true
          data['hasCloudflare'] = true
          data['choiceHDImages'] = finalChoiceHDImages
          dataToSet['choiceHDImages'] = finalChoiceHDImages
        } else if (prevHasCloudflare) {
          nameObject[page][listId]['hasCloudflare'] = deleteField()
          dataToSet['choiceHDImages'] = deleteField()
        }
        choiceHDImagesAction[page](finalChoiceHDImages, dispatch)
      } else if (prevHasCloudflare) {
        nameObject[page][listId]['hasCloudflare'] = deleteField()
        dataToSet['choiceHDImages'] = deleteField()
      }
    }

    const prevHasStorage = hasStorage
    if (dataLength > 990000) {
      // dispatch(asyncActionError('loadingButton'))
      // if (!state.auth.currentUser?.isPremium || !pageSupportsStorage) {
      //   throw new Error('Too many images/inputs, reduce some and try again.')
      // } else {
      const storageData = {
        choices: data.choices,
        ...(finalChoiceHDImages.length > 0 && {
          choiceHDImages: finalChoiceHDImages,
        }),
      }
      promises.push(saveListDataToR2(page, listId, storageData))
      // const storageRef = ref(storage, storagePath)
      // promises.push(uploadString(storageRef, JSON.stringify(storageData)))
      nameObject[page][listId]['hasStorage'] = true
      data['hasStorage'] = true
      const keyName = page === 'rtg' ? 'people' : 'choices'
      dataToSet[keyName] = deleteField()
      dataToSet['choiceHDImages'] = deleteField()

      if (fileSharePath && shareMethod === 'File' && !prevHasStorage) {
        const sharePathRef = doc(
          firestore,
          'share-wheels',
          page,
          'share-links',
          fileSharePath,
        )
        batch.set(sharePathRef, { hasStorage: true }, { merge: true })
      }
      // }
    } else if (pageSupportsStorage && prevHasStorage) {
      nameObject[page][listId]['hasStorage'] = deleteField()
      promises.push(deleteR2StorageData(page, listId))
      // promises.push(deleteUserAsset(`save-lists-${page}`, listId))

      if (fileSharePath && shareMethod === 'File' && prevHasStorage) {
        const sharePathRef = doc(
          firestore,
          'share-wheels',
          page,
          'share-links',
          fileSharePath,
        )
        batch.set(sharePathRef, { hasStorage: deleteField() }, { merge: true })
      }
    }

    batch.set(namesPath, nameObject, { merge: true })
    batch.set(dataPath, dataToSet, { merge: true })
    // await batch.commit()
    promises.push(batch.commit())
    await Promise.all(promises)

    dispatch(setDataStatus('Unchanged'))
    dispatch(setCurrentTabData(data))
    // when hasStorage key is true, prevent store to localstorage
    if (!data.hasStorage) {
      switch (page) {
        case 'main':
          dispatch(saveLocalChoicesList(cloneDeep(data))) // clone deep needed else local save list will also change value based on reference, only save private save list not global share link
          break
        case 'rtg':
          dispatch(saveLocalPeopleList(cloneDeep(data)))
          break
        case 'rig':
          dispatch(saveLocalChoicesListRIG(cloneDeep(data)))
          break
      }
    }
    dispatch(setIsReadingFile(false))
    return {
      error: '',
    }
  } catch (error) {
    // console.log(error)
    dispatch(setIsReadingFile(false))
    if (error.code === 'permission-denied') {
      checkRecoverUser()
    }
    throw error
  }
}

const copyAssets = async (settingsData, listId, userId, page) => {
  const { bgImage, banners, music } = settingsData
  const allPromises = []
  const copyFiles = []
  const nullAssets = []
  if (bgImage.src) {
    //copy from another storage folder
    if (
      bgImage.src.includes('Options') || //not from options
      !bgImage.src.includes(`${page}2F${listId}%2F`) || //not same file
      !bgImage.src.includes(userId) //from other people
    ) {
      copyFiles.push({
        srcUrl: bgImage.src,
        destFolder: `${page}/${listId}`,
        filename: 'bgImage',
      })
    }
  } else {
    nullAssets.push('bgImage')
  }

  if (music.spinning.includes('http')) {
    if (
      music.spinning.includes('Options') ||
      !music.spinning.includes(`${page}%2F${listId}%2F`) ||
      !music.spinning.includes(userId) //from other people
    ) {
      copyFiles.push({
        srcUrl: music.spinning,
        destFolder: `${page}/${listId}`,
        filename: 'spinning',
      })
    }
  } else {
    nullAssets.push('spinning')
  }

  if (music.celebrating.includes('http')) {
    if (
      music.celebrating.includes('Options') ||
      !music.celebrating.includes(`${page}%2F${listId}%2F`) ||
      !music.celebrating.includes(userId) //from other people
    ) {
      copyFiles.push({
        srcUrl: music.celebrating,
        destFolder: `${page}/${listId}`,
        filename: 'ending',
      })
    }
  } else {
    nullAssets.push('ending')
  }

  if (banners.topDesktop?.src) {
    if (
      banners.topDesktop.src.includes('Options') ||
      !banners.topDesktop.src.includes(`${page}%2F${listId}%2F`) ||
      !banners.topDesktop.src.includes(userId) //from other people
    ) {
      copyFiles.push({
        srcUrl: banners.topDesktop.src,
        destFolder: `${page}/${listId}`,
        filename: 'topDesktop',
      })
    }
  } else {
    nullAssets.push('topDesktop')
  }

  if (banners.bottomDesktop?.src) {
    if (
      banners.bottomDesktop.src.includes('Options') ||
      !banners.bottomDesktop.src.includes(`${page}%2F${listId}%2F`) ||
      !banners.bottomDesktop.src.includes(userId) //from other people
    ) {
      copyFiles.push({
        srcUrl: banners.bottomDesktop.src,
        destFolder: `${page}/${listId}`,
        filename: 'bottomDesktop',
      })
    }
  } else {
    nullAssets.push('bottomDesktop')
  }

  if (banners.topMobile?.src) {
    if (
      banners.topMobile.src.includes('Options') ||
      !banners.topMobile.src.includes(`${page}%2F${listId}%2F`) ||
      !banners.topMobile.src.includes(userId) //from other people
    ) {
      copyFiles.push({
        srcUrl: banners.topMobile.src,
        destFolder: `${page}/${listId}`,
        filename: 'topMobile',
      })
    }
  } else {
    nullAssets.push('topMobile')
  }

  if (banners.bottomMobile?.src) {
    if (
      banners.bottomMobile.src.includes('Options') ||
      !banners.bottomMobile.src.includes(`${page}%2F${listId}%2F`) ||
      !banners.bottomMobile.src.includes(userId) //from other people
    ) {
      copyFiles.push({
        srcUrl: banners.bottomMobile.src,
        destFolder: `${page}/${listId}`,
        filename: 'bottomMobile',
      })
    }
  } else {
    nullAssets.push('bottomMobile')
  }

  try {
    if (copyFiles.length > 0) {
      allPromises.push(copyStorageFiles(copyFiles))
    }

    if (nullAssets.length > 0) {
      const unusedAssets = await getUnusedAssetsName(
        `${page}/${listId}`,
        nullAssets,
      )
      if (unusedAssets.length > 0) {
        for (let name of unusedAssets) {
          allPromises.push(deleteUserAsset(`${page}/${listId}`, name))
        }
      }
    }

    if (allPromises.length === 0) return {}
    const resultsArray = await Promise.all(allPromises)
    const results = {}
    for (let result of resultsArray) {
      if (result.data) {
        //for copy files data
        for (let item of result.data) {
          const key = Object.keys(item)[0]
          results[key] = item[key]
        }
      } else {
        const key = Object.keys(result)[0]
        results[key] = result[key]
      }
    }
    return results
  } catch (error) {
    console.log('Error occurred', error)
  }
}

const replaceNewSettings = async (results, settingsData) => {
  const newSettingsData = cloneDeep(settingsData)
  // const cdnUrls = []
  if (results.bgImage) {
    newSettingsData.bgImage.src = results.bgImage
    // cdnUrls.push(replaceCDN(results.bgImage))
  } else if (results.bgImage === null) {
    //copyfiles failed
    newSettingsData.bgImage.src = null
  }

  if (results.spinning) {
    newSettingsData.music.spinning = results.spinning
    // cdnUrls.push(replaceCDN(results.spinning))
  } else if (results.spinning === null) {
    newSettingsData.music.spinning = 'tick-sound'
  }

  if (results.ending) {
    newSettingsData.music.celebrating = results.ending
    // cdnUrls.push(replaceCDN(results.ending))
  } else if (results.ending === null) {
    newSettingsData.music.celebrating = 'celebration-sound'
  }

  if (results.topDesktop) {
    newSettingsData.banners.topDesktop.src = results.topDesktop
    // cdnUrls.push(replaceCDN(results.topDesktop))
  } else if (results.topDesktop === null) {
    delete newSettingsData.banners.topDesktop
  }

  if (results.bottomDesktop) {
    newSettingsData.banners.bottomDesktop.src = results.bottomDesktop
    // cdnUrls.push(replaceCDN(results.bottomDesktop))
  } else if (results.bottomDesktop === null) {
    delete newSettingsData.banners.bottomDesktop
  }

  if (results.topMobile) {
    newSettingsData.banners.topMobile.src = results.topMobile
    // cdnUrls.push(replaceCDN(results.topMobile))
  } else if (results.topMobile === null) {
    delete newSettingsData.banners.topMobile
  }

  if (results.bottomMobile) {
    newSettingsData.banners.bottomMobile.src = results.bottomMobile
    // cdnUrls.push(replaceCDN(results.bottomMobile))
  } else if (results.bottomMobile === null) {
    delete newSettingsData.banners.bottomMobile
  }
  //if want to use purge, enable below
  // if (cdnUrls.length > 0) {
  //   const purgeCdnUrls = httpsCallable(functions, 'purgeCdnUrlsV2')
  //   await purgeCdnUrls({ urls: cdnUrls })
  // }
  return newSettingsData
}

export const deleteList =
  (page, listObject, mayNeedReset = true) =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsReadingFile(true))
      const listId = listObject.id
      const state = getState()
      // const listId = selectedList.id
      const user = auth.currentUser
      const currentFileKey = state.common.currentFileKey
      // const firestore = firebase.firestore()

      const batch = writeBatch(firestore)
      const userDocRef = doc(firestore, 'users', user.uid)
      const namesPath = doc(userDocRef, `save-lists-names`, 'all')

      if (listObject.isCollectShareMethod) {
        const deleteCollectFile = httpsCallable(
          functions,
          'deleteNestedDocUser',
        )
        await deleteCollectFile({
          path: `save-lists-${page}/${listId}`,
          userId: user.uid,
        })
      } else {
        const dataPath = doc(userDocRef, `save-lists-${page}`, listId)
        batch.delete(dataPath)
      }

      batch.update(namesPath, {
        [`${page}.${listId}`]: deleteField(),
      })
      if (listObject.sharePath || listObject.shareId) {
        // for version 1 or 2
        //for share link
        const sharePath = listObject.sharePath || listObject.shareId
        const linkDocRef = doc(
          firestore,
          'share-wheels',
          page,
          'share-links',
          sharePath,
        )
        batch.delete(linkDocRef)
      }
      // await batch.commit()
      const promises = [batch.commit()]

      if (listObject.hasStorage && mayNeedReset) {
        promises.push(deleteR2StorageData(page, listId))
      }
      if (listObject.hasCloudflare && mayNeedReset) {
        // delete all cloudflare images
        promises.push(deleteFolderFromR2(page, listId))
      }
      await Promise.all(promises)

      // if (state.auth.currentUser?.isPremium !== undefined) {
      // only applicable to premium user, non subscribe can't get ispremium
      if (user.uid && listId) {
        //careful use
        const deleteFolder = httpsCallable(functions, 'deleteFolderV2')
        await deleteFolder({
          folderPath: `${user.uid}/${page}/${listId}`,
          userId: user.uid,
        })
      }
      // }d

      if (currentFileKey === listId && mayNeedReset) {
        await dispatch(resetInitialSettings())
        dispatch({
          type: `RESET_INITIAL_STATE_${page.toUpperCase()}`,
        })
        dispatch(setCurrentFileKey(''))
        dispatch(setCurrentTabData({}))
        dispatch(updateCurrentConfig(null))
      }

      if (
        [
          'rng',
          'ynw',
          'rlg',
          'rcg',
          'rsg',
          'nfl',
          'nba',
          'mlb',
          'rdg',
          'cfq',
          'rcw',
          'tdq',
        ].includes(page)
      ) {
        // rng, ynw dont have local saved list, skip below
        return true
      }

      let savedLists = null
      if (page !== 'rtg') {
        savedLists = state[page].savedChoicesList // clone deep needed else local save list will also change value based on reference
      } else {
        savedLists = state.rtg.savedPeopleList
      }

      const newSavedLists = removeObjectField(savedLists, listId)

      switch (page) {
        case 'main':
          dispatch(setSavedLists(newSavedLists))
          break
        case 'rtg':
          dispatch(setSavedListsRTG(newSavedLists))
          break
        case 'rig':
          dispatch(setSavedListsRIG(newSavedLists))
          break
      }
      dispatch(setIsReadingFile(false))
      return true
    } catch (error) {
      dispatch(setIsReadingFile(false))
      if (error.code === 'permission-denied') {
        checkRecoverUser()
      }
      // dispatch(asyncActionError('loadin gButton'))
      throw error
    }
  }

export const updateCustomization = data => async (dispatch, getState) => {
  const user = auth.currentUser
  // const userStore = getState().auth.currentUser
  const newCustomization = {
    customization: {
      ...data,
    },
  }
  const d = doc(firestore, 'users', user.uid)
  dispatch(updateUserCustomization(newCustomization.customization))
  await setDoc(d, newCustomization, { merge: true })
}

// export const deleteCustomizationField = field => async (dispatch, getState) => {
//   const user = auth.currentUser
//   const customizationField = `customization.${field}`
//   const newCustomization = {
//     [customizationField]: deleteField(),
//   }
//   const userStoreCustomization = {
//     ...getState().auth.currentUser.customization,
//   }
//   const newUserStoreCustomization = removeObjectField(
//     userStoreCustomization,
//     customizationField,
//   )
//   const d = doc(firestore, 'users', user.uid)
//   dispatch(updateUserStore({ customization: newUserStoreCustomization }))
//   await updateDoc(d, newCustomization)
// }

// export const updateBannersFirestore = async data => {
//   const user = auth.currentUser
//   const newBanners = {
//     // customization: {
//     banners: {
//       ...data,
//     },
//     // },
//   }

//   const d = doc(firestore, 'users', user.uid)
//   // dispatch(updateBanners(newBanners))
//   await setDoc(d, newBanners, { merge: true })
// }

// export const updateShareWheel = data => async (dispatch, getState) => {
//   const {
//     sharePage,
//     inputChecked,
//     titleChecked,
//     settingsChecked,
//     shareCanEdit,
//     listId,
//     shareId,
//     fileName,
//   } = data
//   const state = getState()

//   const user = auth.currentUser
//   const fSettings = state.settings

//   let toolData = null
//   let settingsData = null
//   switch (sharePage) {
//     case 'main':
//       if (inputChecked) {
//         const fChoices = state.main.choices
//         const weightOn = state.main.weightOn
//         const tempChoices = cloneDeep(fChoices)
//         tempChoices.forEach(choice => {
//           choice.count = 0
//           choice.filtered = false
//           if (!weightOn && choice.weight) {
//             delete choice.weight
//           }
//         })
//         toolData = {
//           choices: tempChoices,
//           mode: 0,
//         }
//         if (weightOn) {
//           toolData['weightOn'] = weightOn
//         }
//       }
//       break
//     case 'rig':
//       if (inputChecked) {
//         const fChoices = state.rig.choices
//         const tempChoices = cloneDeep(fChoices)
//         tempChoices.forEach(choice => {
//           choice.count = 0
//           choice.filtered = false
//         })
//         toolData = {
//           choices: tempChoices,
//           mode: 0,
//         }
//       }
//       break
//   }

//   if (inputChecked && titleChecked) {
//     if (toolData === null) {
//       // in case if the wheel have no inputs
//       toolData = {}
//     }
//     toolData['title'] = { ...state[sharePage].title }
//   }

//   if (settingsChecked) {
//     settingsData = { ...fSettings }
//     if (settingsData.hasOwnProperty('_persist')) {
//       delete settingsData._persist
//     }
//   }

//   const dataFunctions = {
//     tool: toolData,
//     settings: settingsData,
//     websiteMode: shareCanEdit ? 'ShareCanEdit' : 'ShareViewOnly',
//   }

//   // if (shareCanEdit) {
//   //   dataFunctions['websiteMode'] = 'ShareCanEdit'
//   // } else {
//   //   dataFunctions['websiteMode'] = "ShareViewOnly"
//   // }

//   const dataLength = JSON.stringify({ ...dataFunctions }).length
//   if (dataLength > 990000) {
//     //firestore can only store up to 1Mb/doc. check data length less than 1Mb
//     // dispatch(asyncActionError('share'))
//     throw {
//       error: 'Too many images/inputs, reduce some and try again.',
//     }
//   }
//   const batch = writeBatch(firestore)
//   const linkDocRef = doc(
//     firestore,
//     'share-wheels',
//     sharePage,
//     'share-links',
//     shareId,
//   )
//   const userFileDocRef = doc(
//     firestore,
//     'users',
//     user.uid,
//     'save-lists-names',
//     sharePage,
//   )

//   const nameObject = {
//     [listId]: {
//       id: listId,
//       name: fileName,
//       uniqueId: cuid(),
//       shareId: shareId,
//     },
//   }

//   dataFunctions['lastUpdated'] = serverTimestamp()

//   batch.update(linkDocRef, dataFunctions)
//   batch.update(userFileDocRef, nameObject)

//   await batch.commit()
//   return true
// }

// export const deleteShareWheel = async (data, deleteAccessOnly) => {
//   const { sharePage, listId, shareId } = data
//   try {
//     const user = auth.currentUser
//     // const firestore = firebase.firestore()
//     const batch = writeBatch(firestore)
//     const linkDocRef = doc(
//       firestore,
//       'share-wheels',
//       sharePage,
//       'share-links',
//       shareId,
//     )
//     const userFileDocRef = doc(
//       firestore,
//       'users',
//       user.uid,
//       'save-lists-names',
//       sharePage,
//     )
//     if (deleteAccessOnly) {
//       batch.update(linkDocRef, {
//         hasOwner: false,
//         lastUpdated: serverTimestamp(),
//       })
//     } else {
//       batch.delete(linkDocRef)
//     }

//     batch.update(userFileDocRef, {
//       [listId]: deleteField(),
//     })
//     await batch.commit()

//     return true
//   } catch (error) {
//     // dispatch(asyncActionError('loadingButton'))
//     throw error
//   }
// }

export const checkRecoverUser = async (fromLocal = null) => {
  const user = auth.currentUser
  const userData = {
    displayName: user.displayName,
    email: user.email,
    photoURL: user.photoURL || '',
    role: 'subscriber',
    gender: '',
    occupation: '',
    country: '',
    uid: user.uid,
    providerId: user.providerData[0].providerId, //no longer for many use, this is the user first providerid, only for increment and decrement user
    createdAt: user.metadata.createdAt,
    lastActive: user.metadata.lastLoginAt,
    lastRefresh: Date.parse(user.reloadUserInfo.lastRefreshAt),
    fromLocal: fromLocal,
  }
  const createMissingUser = httpsCallable(functions, 'createMissingUserV2')
  await createMissingUser(userData)
}

export const migrateShareOneToShareTwo = async (page, listObject) => {
  const user = auth.currentUser

  const data = {
    fileKey: listObject.id,
    name: listObject.name,
    uniqueId: listObject.uniqueId,
    path: listObject.shareId,
    page: page,
    userId: user.uid,
    useNameListKeyAll: true,
  }

  const migrateShareVersion = httpsCallable(functions, 'migrateShareVersion')
  await migrateShareVersion(data)
}

const processChoiceHDImages = async (choiceHDImages, choices, page, listId) => {
  let finalChoiceHDImages = []
  let keysToDelete = []
  let keysToUpload = []
  const storagePath = `save-lists-${page}/${listId}/`
  for (const imageBlob of choiceHDImages) {
    if (imageBlob.index < choices.length) {
      if (imageBlob.status === 'delete') {
        keysToDelete.push(imageBlob.filename)
      } else if (
        imageBlob.imageUrl.startsWith('blob:') ||
        imageBlob.status === 'duplicate' ||
        !imageBlob.imageUrl.startsWith(storagePath)
      ) {
        keysToUpload.push(imageBlob)
        finalChoiceHDImages.push({
          ...imageBlob,
          imageUrl: `${storagePath}${imageBlob.filename}`,
        })
      } else {
        finalChoiceHDImages.push(imageBlob)
      }
    }
  }

  const promises = []
  if (keysToDelete.length > 0) {
    promises.push(deleteImagesFromR2(keysToDelete, page, listId))
  }
  if (keysToUpload.length > 0) {
    const imageUploadFormData = await prepareImageFormData(
      keysToUpload,
      page,
      listId,
    )
    promises.push(uploadImagesToR2(imageUploadFormData))
  }

  await Promise.all(promises)

  // Remove status key from all objects
  finalChoiceHDImages = finalChoiceHDImages.map(({ status, ...rest }) => rest)

  return finalChoiceHDImages
}
